import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FullScreen = _resolveComponent("FullScreen")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("span", {
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleScreenfullChange && _ctx.handleScreenfullChange(...args))),
    class: "flex align-center"
  }, [
    _createVNode(_component_el_icon, null, {
      default: _withCtx(() => [
        _createVNode(_component_FullScreen)
      ]),
      _: 1
    })
  ]))
}